module.exports = __webpack_public_path__ + "img/main-slide-1.873891de.jpeg";